import { useEffect, useState } from "react";
import { validateEmail } from "../validators/mfaSchema";

type ValidateEmail = 'empty' | 'invalid' | 'invalid_length' | null;

export const useValidateEmail = (email: string) => {
    const [error, setError] = useState<ValidateEmail>(null);

    useEffect(() => {
        const emailErrorState = getEmailError();

        if (!emailErrorState) {
            setError(null);
            return;
        }

        setError(emailErrorState);

        function getEmailError() {
            const errorKeys = validateEmail(email);
            if (errorKeys && errorKeys.includes('enter_your_new_email_address')) {
                return "empty";
            }
            if (errorKeys && errorKeys.includes('the_email_length_is_invalid')) {
                return 'invalid_length';
            }
            if (errorKeys && errorKeys.includes('the_email_is_invalid')) {
                return 'invalid';
            }
        }

    }, [email]);

    return error;
}